import FieldsRenderer from './FieldsRenderer'
export default FieldsRenderer


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/FieldsRenderer/index.js